import { gql } from '@apollo/client';

export const CHECKOUT_PAYMENT = gql`
  mutation checkoutPayment($input: CheckoutPaymentInput!) {
    checkoutPayment(input: $input) {
      paymentComplete
      paymentIntentClientSecret
      subscriptionStatus
      paymentInformation {
        payment {
          id
          state
        }
        bookingProtection {
          protection_type
          protection_fee
          protection_rounding
        }
      }
    }
  }
`;
